import moment from 'moment'

export default function DisplayBidStatus({ isOpen, expiresAt }) {
  if (!isOpen) {
    return (
      <span className="text-red-500 bg-red-50 text-xs px-2 py-1 rounded font-semibold">Closed</span>
    )
  }

  if (moment().isAfter(expiresAt)) {
    return (
      <span className="text-red-500 bg-red-50 text-xs px-2 py-1 rounded font-semibold">
        Expired
      </span>
    )
  }

  return (
    <span className="text-success-600 bg-success/10 text-xs px-2 py-1 rounded font-semibold">
      Open
    </span>
  )
}
